import SingletonService from 'services/utils/singletonService';
import http from 'services/utils/http';

const api = 'signUp';

class SignUp {
    // eslint-disable-next-line class-methods-use-this
    signUp({
        userName,
        companyName, firstName, lastName, city = null,
        country,
        referrerId: referrer,
        utmData: {
            utmMedium, utmSource, utmTerm, utmContent
        },
        password, termsAndConditions: companyTcSigned, captchaResponse,
        noUpdates: unsubscribe
    }) {
        const apiUrl = '/partners/signUp';
        return http.post(apiUrl, {
            userName,
            companyName,
            firstName,
            lastName,
            contactName: `${firstName} ${lastName}`,
            city,
            country,
            referrer,
            utmMedium,
            utmSource,
            utmTerm,
            utmContent,
            password,
            companyTcSigned,
            captchaResponse,
            unsubscribe
        }, false);
    }
}

const singletonService = new SingletonService(api);
if (!singletonService.isInitialized()) {
    singletonService.setService(new SignUp());
}

export default singletonService.getService();
